import * as React from "react";
import Box from "@mui/material/Box";
import { TextField, type ITextFieldStyles } from "@fluentui/react/lib/TextField";
import { LTLState } from "@taskpane/hooks/useLTLReducer";
import { ltlFieldInputId } from "@taskpane/utils/ltlValidationFocus";
import { itemsEditorStyles as styles } from "./itemsEditor.styles";

type ItemRow = LTLState["items"][number];

interface Props {
  item: ItemRow;
  index: number;
  onItemFieldChange: (index: number, field: keyof ItemRow, value: unknown) => void;
  onFieldBlur?: () => void;
  getTextFieldStyles: (fieldKey: string) => unknown;
}

export function LtlFreightItemPackagingRow({
  item,
  index,
  onItemFieldChange,
  onFieldBlur,
  getTextFieldStyles,
}: Props): React.ReactElement {
  const st = (suffix: string) => getTextFieldStyles(`item${index}_${suffix}`) as ITextFieldStyles;

  return (
    <Box sx={styles.row}>
      <Box sx={styles.fieldGroup}>
        <TextField
          label="Packaging"
          value={item.packaging}
          onChange={(e, newValue) => onItemFieldChange(index, "packaging", newValue || "Pallets")}
          onBlur={onFieldBlur}
          id={ltlFieldInputId(`item${index}_packaging`)}
          styles={st("packaging")}
        />
      </Box>
      <Box sx={styles.fieldGroup}>
        <TextField
          label="Packaging Count"
          type="number"
          value={String(item.packagingCount)}
          id={ltlFieldInputId(`item${index}_packagingCount`)}
          styles={st("packagingCount")}
          onChange={(e, newValue) =>
            onItemFieldChange(index, "packagingCount", parseInt(newValue || "1", 10))
          }
          onBlur={onFieldBlur}
        />
      </Box>
    </Box>
  );
}
